import Application from "../../Application";
import GetAllIndexTypeCategoriesInteractor from "../../indexTypes/interactors/GetAllIndexTypeCategoriesInteractor";
import OrganisationIndexCategoryPresenter, {
  IOrganisationIndexCategoryPresenter
} from "../presenter/OrganisationIndexCategoryPresenter";
import GetAllOrganisationIndexCategoriesInteractor from "./GetAllOrganisationIndexCategoriesInteractor";
export default class ShowOrganisationIndexCategoryInteractor {
  private application: Application;
  private output?: IOrganisationIndexCategoryPresenter;
  private getAllOrganisationIndexCategoriesInteractor: GetAllOrganisationIndexCategoriesInteractor;
  private getAllIndexTypeCategoriesInteractor: GetAllIndexTypeCategoriesInteractor;

  constructor({
    application,
    getAllOrganisationIndexCategories,
    getAllIndexTypeCategories
  }) {
    this.application = application;
    this.getAllOrganisationIndexCategoriesInteractor =
      getAllOrganisationIndexCategories;
    this.getAllIndexTypeCategoriesInteractor = getAllIndexTypeCategories;
  }
  private async getAllIndexTypeCategories() {
    return this.getAllIndexTypeCategoriesInteractor.execute();
  }

  private async getReferenceLists() {
    return Promise.all([this.getAllIndexTypeCategories()]);
  }
  execute(organisationId: number) {
    this.output = OrganisationIndexCategoryPresenter({
      application: this.application,
      initialState: {
        organisationId: NaN,
        indexTypeCategories: [],
        organisationIndexCategories: [],
        indexTypeCategoryId: NaN,
        createOrganisationCategoryModalVisible: false
      }
    });

    this.getReferenceLists()
      .then(([registryInstitutions]) =>
        this.output?.loadReferenceValues(registryInstitutions, organisationId)
      )
      .then(() =>
        this.getAllOrganisationIndexCategoriesInteractor.execute(organisationId)
      )
      .then(this.output.loadData);
    return this.output;
  }
}
